<template>
  <div class="footer-fixed">
    <div class="footer-container">
      <div class="footer-image">
        <img v-if="logo" :src="logo" />
      </div>
      <div class="footer-info">
        <div class="footer-copyright" v-if="copyright">
          <p>
            <span>{{ copyright.year }}</span>
            <span class="copyright-name" @click="fowardPage(copyright)">{{ copyright.name }}</span>
            <span>{{ copyright.rights }}</span>
          </p>
        </div>
        <div class="flex flex-center">
          <div class="footer-links" v-for="(item, index) in linkList" :key="index" @click="fowardPage(row)">{{ item.lable }}</div>
        </div>
      </div>
      </div>
  </div>
</template>
<script>
import { getPageFooterInfo } from '@/api/api'

export default {
  data() {
    return {
      logo: 'https://sso.fastorder.my/auth/resources/cw28c/login/fastorder/img/keycloak-logo-text.png',
      copyright: {
        year: '© 2021',
        name: ' FastOrder.my',
        link_url: '',
        rights: ' by GLY Technology & IT Consultancy (002725666-K) | All Rights Reserved.'
      },
      linkList: [
        { lable: 'Privacy Notice', link_url: '' },
        { lable: 'Terms of Use', link_url: '' },
      ]
    }
  },
  components: {
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      getPageFooterInfo("/app/index.php?i=2&c=entry&m=weisrc_dish&do=get_footer_info", {}).then(res => {
        const { logo, copyright, link_list } = res.data
        this.logo = logo
        this.copyright = copyright
        this.linkList = link_list
      }).catch((error) => {
        console.log('getPageFooterInfo====>error', error)
      })
    },
    fowardPage(item) {
      if (item.link_url) {
        window.location.href = item.link_url
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.footer-fixed {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  box-shadow: 0 19px 20px 10px hsla(0,0%,57.3%,.85), -10px 10px 10px 10px hsla(0,0%,100%,.5);
  background: white;

  .footer-container {
    display: flex;
    align-items: center;
    padding: 10px 0;
    
    .footer-image {
      text-align: center;
      width: 60px;
      margin: 0 16px;
      transform: translateY(15%);

      img {
        width: 100%;
      }
    }
    .footer-copyright {
      font-size: 10px;
      text-align: left;
      color: rgba(0, 0, 0, 0.5);
      .copyright-name {
        color: #03a9f4;
      }
    }
    .footer-links {
      font-size: 10px;
      color: #03a9f4;
      margin: 0 13px 0 0;
    }
  }
}
</style>